import { MessageDescriptor } from '@lingui/core';
import { defineMessage } from '@lingui/core/macro';
import { assertUnreachable } from '@luminovo/commons';
import { Tag, TagProps } from '@luminovo/design-system';
import { transEnum } from '@luminovo/frontend-utils';

import { CostType } from '../../extractors';

export const getTcoColor = (costType: CostType): TagProps['color'] => {
    switch (costType) {
        case 'packaging':
            return 'violet';
        case 'discount':
            return 'yellow';
        case 'shipping':
            return 'blue';
        case 'customs':
            return 'green';
        case 'other':
            return 'neutral';
        default:
            assertUnreachable(costType);
    }
};

export const tcoCategoryTranslations: Record<string, MessageDescriptor> = {
    packaging: defineMessage({ message: 'Packaging' }),
    discount: defineMessage({ message: 'Discount' }),
    shipping: defineMessage({ message: 'Shipping' }),
    customs: defineMessage({ message: 'Customs' }),
    other: defineMessage({ message: 'Other' }),
};

export const CostTag = ({ costType }: { costType: CostType }): JSX.Element => {
    const color = getTcoColor(costType);
    const label = transEnum(costType, tcoCategoryTranslations);

    return <Tag color={color} label={label} attention="low" />;
};
